import React from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import { Modal, Typography } from '@thingsw/pitta-design-system';
import { ICameraInfo, LightColors } from '@thingsw/pitta-modules';
import { useSelector } from 'react-redux';
import { RootState } from '../../features/store';
import { THEME } from '../../features/Theme/slice';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    maxWidth: 460,
  },
  container: {
    padding: '24px 32px',
  },
  titleDiv: {
    marginBottom: 24,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  rButton: {
    background: (props: any) => props.secondaryColors.primary['7'],
    color: LightColors.primary['0'],
    width: '100%',

    '&:hover': {
      background: (props: any) => props.secondaryColors.primary['7'],
    },
  },
}));

interface BatteryConnectionFailModalProps {
  openBatteryFailModal: boolean;
  setOpenBatteryFailModal: (open: boolean) => void;
  camera: ICameraInfo | undefined;
}

const BatteryConnectionFailModal = (props: BatteryConnectionFailModalProps) => {
  const { t } = useTranslation();
  const { colors, secondaryColors } = useSelector(
    (root: RootState) => root[THEME]
  );

  const { openBatteryFailModal, setOpenBatteryFailModal } = props;

  const classes = useStyles({ ...props, colors, secondaryColors });

  return (
    <Modal
      open={openBatteryFailModal}
      noPadding
      RButton={t('OK')}
      fullWidthBtn
      RButtonClassName={classes.rButton}
      className={classes.root}
      onClickPositive={() => setOpenBatteryFailModal(false)}
      content={
        <div className={classes.container}>
          <div className={classes.titleDiv}>
            <Typography variant='H6' htmlColor={colors.primary['1']}>
              {t('Cannot connect to the battery')}
            </Typography>
          </div>
          <div>
            <Typography variant='Body' htmlColor={colors.primary['1']}>
              {t('Please check the Cloud connection of the camera.')}
            </Typography>
          </div>
        </div>
      }
    />
  );
};

export default BatteryConnectionFailModal;
